import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { RouterState } from "react-router-redux";
import { Helmet } from "react-helmet";
import { FacebookProvider, CustomChat } from "react-facebook";

import { NotFound, RuntimeError, ErrorBoundary } from "./components";
import LandingPage from "./routes/LandingPage";
import Wizard from "./routes/Wizard";
import Success from "./routes/OrderSuccess";
import StaticPages from "./routes/StaticPages";
import Account from "./routes/Account";
import { FACEBOOK_APPID } from "./routes/LandingPage/constants";

export interface AppProps extends RouterState {}

const App = (props: AppProps) => (
  <div className="app">
    <ErrorBoundary component={RuntimeError}>
      <Helmet titleTemplate="%s | ExpressDesign">
        <meta
          name="description"
          content="Website đặt hàng thiết kế trực tuyến - Đặt thiết kế trong 5 phút nhận sản phẩm ngay trong ngày"
        />
        <meta property="og:site_name" content="ExpressDesign" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Website đặt hàng thiết kế trực tuyến - Đặt thiết kế trong 5 phút nhận sản phẩm ngay trong ngày"
        />
        <meta name="twitter:card" content="website" />
        <meta
          name="twitter:description"
          content="Website đặt hàng thiết kế trực tuyến - Đặt thiết kế trong 5 phút nhận sản phẩm ngay trong ngày"
        />
        <meta property="fb:app_id" content={FACEBOOK_APPID} />
      </Helmet>
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route path="/wizard" component={Wizard} />
        <Route exact path="/order/success" component={Success} />
        <Route path="/pages" component={StaticPages} />
        <Route path="/account" component={Account} />
        <Route component={NotFound} />
      </Switch>
      <FacebookProvider version="v2.11" appId={process.env.REACT_APP_FBAPP_ID}>
        <CustomChat
          minimized="false"
          dataRef="website"
          pageId={process.env.REACT_APP_FBPAGE_ID}
        />
      </FacebookProvider>
    </ErrorBoundary>
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx